const LOCAL_SUGGESTIONS = [
  {
    id: 'local-1',
    label: '78 Canal Street, Manchester, M1 5QE',
    lines: ['78 Canal Street', '', 'Manchester', 'M1 5QE']
  },
  {
    id: 'local-2',
    label: '45 Oak Street, Manchester, M1 4GH',
    lines: ['45 Oak Street', 'Flat 2B', 'Manchester', 'M1 4GH']
  },
  {
    id: 'local-3',
    label: '12 River Lane, Salford, M3 1PA',
    lines: ['12 River Lane', '', 'Salford', 'M3 1PA']
  },
  {
    id: 'local-4',
    label: '19 North Road, Leeds, LS1 4AP',
    lines: ['19 North Road', '', 'Leeds', 'LS1 4AP']
  }
];

function parseMapboxFeature(feature) {
  const line1 = [feature.address, feature.text].filter(Boolean).join(' ').trim();
  const context = feature.context || [];
  const findContext = (prefix) =>
    context.find((item) => item.id && item.id.startsWith(prefix));
  const place = findContext('place')?.text || findContext('locality')?.text || '';
  const postcode = findContext('postcode')?.text || '';
  return {
    id: feature.id,
    label: [line1, place, postcode].filter(Boolean).join(', '),
    lines: [line1, '', place, postcode]
  };
}

export default class AddressService {
  constructor({ token } = {}) {
    this.token = token || process.env.REACT_APP_MAPBOX_TOKEN || '';
  }

  async search(query) {
    const clean = query.trim();
    if (clean.length < 3) return [];
    if (this.token) {
      return this.searchMapbox(clean);
    }
    return LOCAL_SUGGESTIONS.filter((item) =>
      item.label.toLowerCase().includes(clean.toLowerCase())
    ).slice(0, 5);
  }

  async searchMapbox(query) {
    const url =
      `https://api.mapbox.com/geocoding/v5/mapbox.places/` +
      `${encodeURIComponent(query)}.json?autocomplete=true&limit=5&types=address&access_token=${this.token}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Address lookup failed');
    }
    const data = await response.json();
    const features = data.features || [];
    return features.map(parseMapboxFeature);
  }
}
